import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import RadioButton from 'app/components/shared/RadioButton';

import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';
import Checkbox from 'app/components/shared/Checkbox';
import { VIOLATION_TYPES } from 'app/constants/FlagsConstants';
import './StandardsViolationForm.scss';

export default class StandardsViolationForm extends React.PureComponent {
  state = {
    violationType: null,
    standardsReviewed: false
  };

  handleViolationTypeChange = value => this.setState({ violationType: value });

  render() {
    const { handleSubmit, isLoading } = this.props;
    return (
      <div className="cp-standards-violation-form">
        <ModalHeader title={<FormattedMessage id="flag_appropriate_use_standards" />} />
        <ModalContent>
          <span className="use-standards-note">
            <FormattedMessage
              id="appropriate_use_standards_note"
              values={{
                link: (...contents) => (
                  <a href="/info/terms" data-key="use-standards-link">
                    {contents}
                  </a>
                )
              }}
            />
          </span>
          <ul className="violation-types-list">
            {Object.values(VIOLATION_TYPES).map(violationType => (
              <RadioButton
                checked={this.state.violationType === violationType}
                handleChange={this.handleViolationTypeChange}
                id={`select-${violationType}`}
                label={<FormattedMessage id={`violation_reason_${violationType.toLowerCase()}`} />}
                name="select-violation-type"
                value={violationType}
                key={violationType}
                dataKey={`select-${violationType}`}
              />
            ))}
          </ul>
          <Checkbox
            id="standards-reviewed-confirmation"
            dataKey="standards-reviewed-confirmation"
            label={<FormattedMessage id="standards_reviewed" />}
            checked={this.state.standardsReviewed}
            handleChange={value => this.setState({ standardsReviewed: value })}
          />
        </ModalContent>
        <ModalFooter
          primaryActionButtonText={<FormattedMessage id="button_submit" />}
          primaryActionButtonTag={TransactionalSolidButton}
          handlePrimaryAction={() => handleSubmit({ violationType: this.state.violationType })}
          isLoading={isLoading}
          disabled={!this.state.violationType || !this.state.standardsReviewed}
        />
      </div>
    );
  }
}

StandardsViolationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};
